import axiosClient from './axiosClient';

const walletService = {
    vendorWallet: async () => {
        const response = await axiosClient.get('/vendor/wallet');
        return response.data.data;
    },

    getBanks: async () => {
        const response = await axiosClient.get('/vendor/wallet/banks');
        return response.data.data;
    },
    vendorWalletTransactions: async (params) => {
        const response = await axiosClient.get('/vendor/wallet/transactions', { params });
        return response.data.data;
    },
    requestWalletWithdrawal: async (amount) => {
        const response = await axiosClient.post('/vendor/wallet/withdraw', { amount });
        return response.data.data;
    },
    getSystemWallet: async () => {
        const response = await axiosClient.get('/admin/wallets/platform/system-wallet');
        return response.data.data;
    },

    getMonnifyBalance: async () => {
        const response = await axiosClient.get('/admin/wallets/monnify/balance');
        return response.data;
    },

    adminWalletFunding: async ({ amount, owner, role, remark, type }) => {
        let response;
        if (type === 'CREDIT') response = await axiosClient.post('/admin/wallets/fund', { amount, owner, role, remark });
        if (type === 'DEBIT') response = await axiosClient.post('/admin/wallets/deduct', { amount, owner, role, remark });
        console.log(response.data.data);
        return response.data.data;
    },

    getVirtualAccount: async () => {
        const response = await axiosClient.get('/vendor/wallet/virtual-account');
        return response.data.data;
    },

    adminGetVirtualAccount: async (walletId) => {
        const response = await axiosClient.get(`/admin/wallets/${walletId}/virtual-account`);
        return response.data.data;
    },

    adminRegenerateVirtualAccount: async (walletId) => {
        const response = await axiosClient.post(`/admin/wallets/${walletId}/virtual-account/regenerate`);
        return response.data;
    }
};

export default walletService;
